// import React, { useEffect, useState, useRef } from "react";
// import { Link, useLocation } from "react-router-dom";
// import { AimantraNameLogo, DropdownArrowClosed, DropdownArrowLine, DropdownArrowLineClosed } from "../components/AllSvg";
// import axios from "axios";
// import { BASE_URL } from "../config/axios";
// import { handleErrorToast } from "../components/CustomFunctions";

// // const SidebarDropDown = (props) => {
// //   let { data, index, currentPath, isexpand } = props;
// //   currentPath = currentPath.split("/");
// //   let paths = currentPath[2];

// //   const [open, setOpen] = useState(data.subMenu?.some(item => item.userId === paths));
// //   const [hoverOpen, setHoverOpen] = useState(false);

// //   const handleDocumentClick = (e) => {
// //     if (e.target.closest(".dashboard-sidebar-middle-menu-split") !== null) return;
// //     setOpen(false);
// //   };

// //   useEffect(() => {
// //     document.addEventListener("click", handleDocumentClick);
// //     return () => {
// //       document.removeEventListener("click", handleDocumentClick);
// //     };
// //   }, []);

// //   return (
// //     <>
// //       <div
// //         className={isexpand ? "dashboard-sidebar-middle-menu-split tooltipp-container" : "dashboard-sidebar-middle-menu-split-closed tooltipp-container"}
// //         key={index}
// //         onClick={() => isexpand && setOpen(!open)}
// //         onMouseEnter={() => !isexpand && setHoverOpen(true)}
// //         onMouseLeave={() => !isexpand && setHoverOpen(false)}
// //         style={{ position: "relative" }}
// //       >
// //         <div className={isexpand ? "dashboard-sidebar-middle-menu" : "dashboard-sidebar-middle-menu-closed"}>

// //           {
// //             data.subMenu.length === 1 ?
// //               <Link to={`${data.subMenu[0].userId}`}>
// //                 <div
// //                   dangerouslySetInnerHTML={{
// //                     __html: data.subMenu?.some(item => item.userId === paths)
// //                       ? data.svgfill
// //                       : data.svg
// //                   }}
// //                 />
// //               </Link>
// //               :
// //               <div
// //                 dangerouslySetInnerHTML={{
// //                   __html: data.subMenu?.some(item => item.userId === paths)
// //                     ? data.svgfill
// //                     : data.svg
// //                 }}
// //               />
// //           }
// //           {isexpand && (
// //             <h2
// //               className="sidebarname font-weight400 font-size-heading"
// //               style={{
// //                 color: data.subMenu?.some(item => item.userId === paths)
// //                   ? "#2576BC"
// //                   : "#707070",
// //                 marginLeft: "10px",
// //                 marginTop: "10px"
// //               }}
// //             >
// //               {data.name}
// //             </h2>
// //           )}
// //         </div>

// //         {isexpand ? (
// //           open ?
// //             (
// //               <DropdownArrowLine color={data.subMenu?.some(item => item.userId === paths) ? "#2576BC" : "#707070"} />
// //             )
// //             :
// //             (
// //               <DropdownArrowLineClosed color={data.subMenu?.some(item => item.userId === paths) ? "#2576BC" : "#707070"} />
// //             )
// //         )
// //           : ""}
// //         {!isexpand ?
// //           hoverOpen &&
// //           (
// //             <div className="sidebarpopup" style={{
// //               position: "absolute",
// //               top: 0,
// //               left: "100%",
// //               background: "#fff",
// //               boxShadow: "0 0 10px rgba(0,0,0,0.1)",
// //               borderRadius: "6px",
// //               padding: "8px",
// //               zIndex: 10,
// //               width: "200px"
// //             }}>
// //               {data.subMenu.length === 0 &&
// //                 <h2
// //                   className="sidebarname font-weight400 font-size-heading"
// //                   style={{
// //                     color: data.subMenu.some((f) => f.userId === paths) ? "#2576BC" : "#707070",
// //                     // paddingBottom: "6px",
// //                     cursor: 'not-allowed'
// //                   }}
// //                 >
// //                   No Management Authority
// //                 </h2>}
// //               {data.subMenu.length > 1 &&
// //                 <h2
// //                   className="sidebarname font-weight400 font-size-heading"
// //                   style={{
// //                     color: data.subMenu.some((f) => f.userId === paths) ? "#2576BC" : "#707070",
// //                     paddingBottom: "6px",
// //                     borderBottom: "1px solid #eee"
// //                   }}
// //                 >
// //                   {data.name}
// //                 </h2>}
// //               {data.subMenu.map((e, subIndex) => (
// //                 <Link
// //                   to={`${e.userId}`}
// //                   className="dashboard-sidebar-middle-menu-sublist  tooltipp-container"
// //                   key={subIndex}
// //                   style={{
// //                     display: "flex",
// //                     alignItems: "center",
// //                     padding: "6px 0",
// //                     color: e.userId === paths ? "#2576BC" : "#707070",
// //                     textDecoration: "none",
// //                     gap: "8px"
// //                   }}
// //                 >
// //                   <div
// //                     dangerouslySetInnerHTML={{ __html: e.userId === paths ? e.svgfill : e.svg }}
// //                     style={{ width: "20px", height: "20px" }}
// //                   />
// //                   <hr />
// //                   <div className="font-size-subheading heading">
// //                     {e.name}
// //                   </div>
// //                 </Link>
// //               ))}
// //             </div>
// //           )
// //           : null}
// //       </div>
// //       {isexpand && open ? (
// //         <div>
// //           {data.subMenu.map((e, index) => {
// //             return (
// //               <Link
// //                 to={`${e.userId}`}
// //                 className="dashboard-sidebar-middle-menu-sublist tooltipp-container"
// //                 key={index}
// //                 style={{
// //                   color: e.userId === paths ? "#2576BC" : "#707070",
// //                 }}
// //               >
// //                 <DropdownArrowLineClosed color={e.userId === paths ? "#2576BC" : "#707070"} />
// //                 <div
// //                   dangerouslySetInnerHTML={{ __html: e.userId === paths ? e.svgfill : e.svg }}
// //                   style={{ width: "20px", height: "20px" }}
// //                 />
// //                 <h3
// //                   style={{
// //                     marginLeft: "10px",
// //                     marginTop: "10px"
// //                   }}
// //                   className=" font-size-subheading  heading">
// //                   {e.name}
// //                 </h3>
// //               </Link>
// //             );
// //           })}
// //         </div>
// //       ) : null}
// //     </>
// //   );
// // };


// const SidebarDropDown = (props) => {
//   let { data, index, currentPath, isexpand, mobileMenuOpen } = props;
//   currentPath = currentPath.split("/");
//   let paths = currentPath[2];

//   const [open, setOpen] = useState(data.subMenu?.some(item => item.userId === paths));
//   const [hoverOpen, setHoverOpen] = useState(false);
//   const containerRef = useRef(null);

//   const handleDocumentClick = (e) => {
//     if (containerRef.current && containerRef.current.contains(e.target)) return;
//     setOpen(false);
//     setHoverOpen(false);
//   };

//   useEffect(() => {
//     document.addEventListener("click", handleDocumentClick);
//     return () => document.removeEventListener("click", handleDocumentClick);
//   }, []);

//   const handleClick = (e) => {
//     e.stopPropagation();
//     if (isexpand) {
//       setOpen(prev => !prev);      // Desktop expanded: inline dropdown
//     } else {
//       setHoverOpen(prev => !prev); // Mobile OR desktop collapsed: toggle popup/inline
//     }
//   };

//   return (
//     <>
//       {/* ── Parent item: ALWAYS uses isexpand for visuals, never mobileMenuOpen ── */}
//       <div
//         ref={containerRef}
//         className={
//           isexpand
//             ? "dashboard-sidebar-middle-menu-split tooltipp-container"
//             : "dashboard-sidebar-middle-menu-split-closed tooltipp-container"
//         }
//         key={index}
//         onClick={handleClick}
//         onMouseEnter={() => {
//           // Hover only on desktop collapsed (not mobile)
//           if (!isexpand && !mobileMenuOpen) setHoverOpen(true);
//         }}
//         onMouseLeave={() => {
//           if (!isexpand && !mobileMenuOpen) setHoverOpen(false);
//         }}
//         style={{ position: "relative" }}
//       >
//         <div className={isexpand ? "dashboard-sidebar-middle-menu" : "dashboard-sidebar-middle-menu-closed"}>
//           {data.subMenu.length === 1 ? (
//             <Link to={`${data.subMenu[0].userId}`}>
//               <div
//                 dangerouslySetInnerHTML={{
//                   __html: data.subMenu?.some(item => item.userId === paths) ? data.svgfill : data.svg,
//                 }}
//               />
//             </Link>
//           ) : (
//             <div
//               dangerouslySetInnerHTML={{
//                 __html: data.subMenu?.some(item => item.userId === paths) ? data.svgfill : data.svg,
//               }}
//             />
//           )}

//           {/* Name only shows when isexpand=true (desktop expanded) */}
//           {isexpand && (
//             <h2
//               className="sidebarname font-weight400 font-size-heading"
//               style={{
//                 color: data.subMenu?.some(item => item.userId === paths) ? "#2576BC" : "#707070",
//                 marginLeft: "10px",
//                 marginTop: "10px",
//               }}
//             >
//               {data.name}
//             </h2>
//           )}
//         </div>

//         {/* Arrow only in desktop expanded */}
//         {isexpand ? (
//           open ? (
//             <DropdownArrowLine color={data.subMenu?.some(item => item.userId === paths) ? "#2576BC" : "#707070"} />
//           ) : (
//             <DropdownArrowLineClosed color={data.subMenu?.some(item => item.userId === paths) ? "#2576BC" : "#707070"} />
//           )
//         ) : null}

//         {/* ── DESKTOP COLLAPSED: hover popup to the right ── */}
//         {!isexpand && !mobileMenuOpen && hoverOpen && (
//           <div
//             className="sidebarpopup"
//             style={{
//               position: "absolute",
//               top: 0,
//               left: "100%",
//               background: "#fff",
//               boxShadow: "0 0 10px rgba(0,0,0,0.1)",
//               borderRadius: "6px",
//               padding: "8px",
//               zIndex: 10,
//               width: "200px",
//             }}
//           >
//             {data.subMenu.length === 0 && (
//               <h2
//                 className="sidebarname font-weight400 font-size-heading"
//                 style={{ color: "#707070", cursor: "not-allowed" }}
//               >
//                 No Management Authority
//               </h2>
//             )}
//             {data.subMenu.length > 1 && (
//               <h2
//                 className="sidebarname font-weight400 font-size-heading"
//                 style={{
//                   color: data.subMenu.some(f => f.userId === paths) ? "#2576BC" : "#707070",
//                   paddingBottom: "6px",
//                   borderBottom: "1px solid #eee",
//                 }}
//               >
//                 {data.name}
//               </h2>
//             )}
//             {data.subMenu.map((e, subIndex) => (
//               <Link
//                 to={`${e.userId}`}
//                 className="dashboard-sidebar-middle-menu-sublist tooltipp-container"
//                 key={subIndex}
//                 onClick={() => setHoverOpen(false)}
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   padding: "6px 0",
//                   color: e.userId === paths ? "#2576BC" : "#707070",
//                   textDecoration: "none",
//                   gap: "8px",
//                 }}
//               >
//                 <div
//                   dangerouslySetInnerHTML={{ __html: e.userId === paths ? e.svgfill : e.svg }}
//                   style={{ width: "20px", height: "20px" }}
//                 />
//                 <div className="font-size-subheading heading">{e.name}</div>
//               </Link>
//             ))}
//           </div>
//         )}
//       </div>

//       {/* ── DESKTOP EXPANDED: inline submenu in expanded style ── */}
//       {isexpand && open && (
//         <div>
//           {data.subMenu.map((e, i) => (
//             <Link
//               to={`${e.userId}`}
//               className="dashboard-sidebar-middle-menu-sublist tooltipp-container"
//               key={i}
//               style={{ color: e.userId === paths ? "#2576BC" : "#707070" }}
//             >
//               <DropdownArrowLineClosed color={e.userId === paths ? "#2576BC" : "#707070"} />
//               <div
//                 dangerouslySetInnerHTML={{ __html: e.userId === paths ? e.svgfill : e.svg }}
//                 style={{ width: "20px", height: "20px" }}
//               />
//               <h3 style={{ marginLeft: "10px", marginTop: "10px" }} className="font-size-subheading heading">
//                 {e.name}
//               </h3>
//             </Link>
//           ))}
//         </div>
//       )}

//       {/* ── MOBILE: inline submenu in COLLAPSED style (matches other sidebar items) ── */}
//       {!isexpand && mobileMenuOpen && hoverOpen && (
//         <div>
//           {data.subMenu.map((e, i) => (
//             <Link
//               to={`${e.userId}`}
//               key={i}
//               className="dashboard-sidebar-middle-menu-closed tooltipp-container"
//               onClick={() => setHoverOpen(false)}
//               style={{
//                 color: e.userId === paths ? "#2576BC" : "#707070",
//                 display: "flex",
//                 flexDirection: "column",
//                 alignItems: "center",
//               }}
//             >
//               {/* Same icon style as other collapsed items */}
//               <div
//                 className="tooltippp"
//                 dangerouslySetInnerHTML={{ __html: e.userId === paths ? e.svgfill : e.svg }}
//               />
//               {/* Same label style as other collapsed items */}
//               <div
//                 className="tooltipp"
//                 style={{ color: e.userId === paths ? "#2576BC" : "#707070" }}
//               >
//                 {e.name}
//               </div>
//             </Link>
//           ))}
//         </div>
//       )}
//     </>
//   );
// };


// const SidebarLink = (props) => {
//   const { data, index, currentPath, isexpand } = props;
//   let paths = currentPath.split("/");
//   paths = paths[2];
//   return (
//     <Link
//       to={`${data.userId}`}
//       className={`${isexpand ? 'justify-start' : 'justify-center'} dashboard-sidebar-middle-menu-closed tooltipp-container`}
//       key={index}
//     >
//       <div className="tooltippp" dangerouslySetInnerHTML={{ __html: data.userId === paths ? data.svgfill : data.svg }} />
//       {!isexpand &&
//         <div className="tooltipp"
//           style={{
//             color: data.userId === paths ? "#2576BC" : "#707070",
//           }}
//         >
//           {data.name}
//         </div>
//       }
//       {isexpand &&
//         <h2
//           className="sidebarname font-weight400 font-size-heading"
//           style={{
//             color: data.userId === paths ? "#2576BC" : "#707070",
//             marginLeft: "10px",
//             marginTop: "10px"
//           }}
//         >
//           {data.name}
//         </h2>}
//     </Link >
//   );
// };

// const DashboardSidebar = (props) => {
//   const { sidebarData, isexpand, setExpanded, mobileMenuOpen, closeMobileMenu } = props;
//   const [currentPath, setCurrentPath] = useState(window.location.pathname);
//   const location = useLocation();
//   const [subCompany, setSubCompany] = useState({});

//   useEffect(() => {
//     setCurrentPath(window.location.pathname);
//   }, [location]);


//   const handleFormSubmit = async (e) => {
//     e.preventDefault();
//     setExpanded(!isexpand)
//   };

//   const subCompanyId = sessionStorage.getItem('company_id');

//   const getSubCompany = async (subcompanyId) => {
//     try {
//       const res = await axios.get(
//         `${BASE_URL}/wfm/subcompany-by-id/${subcompanyId}/`
//       );
//       setSubCompany(res.data);
//     } catch (err) {
//       handleErrorToast(err)
//     }
//   };

//   useEffect(() => {
//     if (subCompanyId) {
//       getSubCompany(subCompanyId);
//     }
//   }, [subCompanyId]);

//   return (
//     // <div className={isexpand ? "dashboard-main-sidebar-section" : "dashboard-main-sidebar-section-closed"}>
//     <div className={`
//       ${isexpand ? "dashboard-main-sidebar-section" : "dashboard-main-sidebar-section-closed"}
//       ${mobileMenuOpen ? "mobile-open" : ""}
//     `}>
//       {/* <div className="fixed-nav"> */}
//       <div className="">

//         <div className="align-center">
//           {/* <img className="sidebar-closed-logo-cipl " src="https://cipl-aimantra.s3.ap-south-1.amazonaws.com/Logos/Cipl+Logo++(1).png" alt="logo" /> */}
//           {/* <img className="sidebar-closed-logo-cipl " src="/logo.png" alt="logo" /> */}
//           {/* {!isexpand ?
//             <img className="sidebar-closed-logo-cipl " src="/logo.png" alt="logo" />
//             :
//             <AimantraNameLogo />
//           } */}
//           {!isexpand ?
//             (
//               subCompany?.company_logo ? (
//                 <img className="sidebar-closed-logo-cipl " src={subCompany?.company_logo}
//                   alt={subCompany?.title} />
//               ) : (<img className="sidebar-closed-logo-cipl " src="/logo.png" alt="logo" />)
//             )
//             :
//             <AimantraNameLogo />
//             // (
//             //   subCompany?.company_logo ? (
//             //     <img className="sidebar-closed-logo-cipl " src={subCompany?.company_logo}
//             //       alt={subCompany?.title} />
//             //   ) : (
//             //     <AimantraNameLogo />
//             //   )
//             // )
//           }
//         </div>

//         <div className={` font-weight400 font-size-subheading ${isexpand ? "align-center" : ""}`}>
//           <button className="sidebar-title" onClick={handleFormSubmit}>
//             Menu
//           </button>
//           {/* {!isexpand && <br />}
//           <button onClick={handleFormSubmit}>
//             {isexpand ?
//               <DropdownArrowLine />
//               :
//               <DropdownArrowLineClosed />}

//           </button> */}

//         </div>
//         <div>
//           {sidebarData.map((data, index) => {
//             return data.subMenu ? (
//               <SidebarDropDown
//                 data={data}
//                 currentPath={currentPath}
//                 index={index}
//                 isexpand={isexpand}
//                 mobileMenuOpen={mobileMenuOpen}
//                 onClick={closeMobileMenu}
//               />
//             ) : (
//               <SidebarLink data={data} currentPath={currentPath} index={index} isexpand={isexpand} key={index} onClick={closeMobileMenu} />
//             );
//           })}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default DashboardSidebar
import React, { useEffect, useState, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import { AimantraNameLogo, DropdownArrowLine, DropdownArrowLineClosed } from "../components/AllSvg";
import axios from "axios";
import { BASE_URL } from "../config/axios";
import { handleErrorToast } from "../components/CustomFunctions";

// ------------------------------------------------------------
// SidebarDropDown – unified for desktop & mobile expanded
// ------------------------------------------------------------
const SidebarDropDown = (props) => {
  const { data, index, currentPath, expanded, mobileMenuOpen, onSubItemClick } = props; // expanded = effective expand
  const pathSegments = currentPath.split("/");
  const paths = pathSegments[2];

  const [open, setOpen] = useState(data.subMenu?.some(item => item.userId === paths));
  const [hoverOpen, setHoverOpen] = useState(false);
  const containerRef = useRef(null);

  // Close on outside click
  useEffect(() => {
    const handleDocumentClick = (e) => {
      if (containerRef.current && containerRef.current.contains(e.target)) return;
      setOpen(false);
      setHoverOpen(false);
    };
    document.addEventListener("click", handleDocumentClick);
    return () => document.removeEventListener("click", handleDocumentClick);
  }, []);

  const handleClick = (e) => {
    e.stopPropagation();
    if (expanded) {
      setOpen(prev => !prev);          // expanded: toggle inline submenu
    } else {
      setHoverOpen(prev => !prev);     // collapsed (desktop): toggle popup
    }
  };
  

  return (
    <>
      <div
        ref={containerRef}
        className={
          expanded
            ? "dashboard-sidebar-middle-menu-split tooltipp-container"
            : "dashboard-sidebar-middle-menu-split-closed tooltipp-container"
        }
        key={index}
        onClick={handleClick}
        onMouseEnter={() => {
          // hover only on desktop collapsed (not mobile)
          if (!expanded && !mobileMenuOpen) setHoverOpen(true);
        }}
        onMouseLeave={() => {
          if (!expanded && !mobileMenuOpen) setHoverOpen(false);
        }}
        style={{ position: "relative" }}
      >
        <div className={expanded ? "dashboard-sidebar-middle-menu" : "dashboard-sidebar-middle-menu-closed"}>
          {data.subMenu.length === 1 ? (
            <Link to={`${data.subMenu[0].userId}`}>
              <div
                dangerouslySetInnerHTML={{
                  __html: data.subMenu?.some(item => item.userId === paths) ? data.svgfill : data.svg,
                }}
              />
            </Link>
          ) : (
            <div
              dangerouslySetInnerHTML={{
                __html: data.subMenu?.some(item => item.userId === paths) ? data.svgfill : data.svg,
              }}
            />
          )}

          {/* Name only when expanded */}
          {expanded && (
            <h2
              className="sidebarname font-weight400 font-size-heading"
              style={{
                color: data.subMenu?.some(item => item.userId === paths) ? "#2576BC" : "#707070",
                marginLeft: "10px",
                marginTop: "10px",
              }}
            >
              {data.name}
            </h2>
          )}
        </div>

        {/* Arrow only in expanded mode */}
        {expanded && (
          open ? (
            <DropdownArrowLine color={data.subMenu?.some(item => item.userId === paths) ? "#2576BC" : "#707070"} />
          ) : (
            <DropdownArrowLineClosed color={data.subMenu?.some(item => item.userId === paths) ? "#2576BC" : "#707070"} />
          )
        )}

        {/* ── Desktop collapsed: hover popup ── */}
        {!expanded && !mobileMenuOpen && hoverOpen && (
          <div
            className="sidebarpopup"
            style={{
              position: "absolute",
              top: 0,
              left: "100%",
              background: "#fff",
              boxShadow: "0 0 10px rgba(0,0,0,0.1)",
              borderRadius: "6px",
              padding: "8px",
              zIndex: 10,
              width: "200px",
            }}
          >
            {data.subMenu.length === 0 && (
              <h2 className="sidebarname font-weight400 font-size-heading" style={{ color: "#707070", cursor: "not-allowed" }}>
                No Management Authority
              </h2>
            )}
            {data.subMenu.length > 1 && (
              <h2
                className="sidebarname font-weight400 font-size-heading"
                style={{
                  color: data.subMenu.some(f => f.userId === paths) ? "#2576BC" : "#707070",
                  paddingBottom: "6px",
                  borderBottom: "1px solid #eee",
                }}
              >
                {data.name}
              </h2>
            )}
            {data.subMenu.map((e, subIndex) => (
              <Link
                to={`${e.userId}`}
                className="dashboard-sidebar-middle-menu-sublist tooltipp-container"
                key={subIndex}
                onClick={() => {
                  setHoverOpen(false); // Keeps existing local logic
                  if(onSubItemClick) onSubItemClick();
                }}
                style={{
                  display: "flex",
                  alignItems: "center",
                  padding: "6px 0",
                  color: e.userId === paths ? "#2576BC" : "#707070",
                  textDecoration: "none",
                  gap: "8px",
                }}
              >
                <div
                  dangerouslySetInnerHTML={{ __html: e.userId === paths ? e.svgfill : e.svg }}
                  style={{ width: "20px", height: "20px" }}
                />
                <div className="font-size-subheading heading">{e.name}</div>
              </Link>
            ))}
          </div>
        )}
      </div>

      {/* ── Expanded inline submenu (both desktop & mobile) ── */}
      {expanded && open && (
        <div>
          {data.subMenu.map((e, i) => (
            <Link
              to={`${e.userId}`}
              className="dashboard-sidebar-middle-menu-sublist tooltipp-container"
              key={i}
              style={{ color: e.userId === paths ? "#2576BC" : "#707070" }}
              onClick={(e) => {
                e.stopPropagation(); // Prevents the parent div's toggle logic
                setOpen(false);      // Closes the dropdown
                if (onSubItemClick) onSubItemClick(); // Closes the mobile menu
              }}
            >
              <DropdownArrowLineClosed color={e.userId === paths ? "#2576BC" : "#707070"} />
              <div
                dangerouslySetInnerHTML={{ __html: e.userId === paths ? e.svgfill : e.svg }}
                style={{ width: "20px", height: "20px" }}
              />
              <h3 style={{ marginLeft: "10px", marginTop: "10px" }} className="font-size-subheading heading">
                {e.name}
              </h3>
            </Link>
          ))}
        </div>
      )}
    </>
  );
};

// ------------------------------------------------------------
// SidebarLink – similar, uses `expanded`
// ------------------------------------------------------------
const SidebarLink = (props) => {
  const { data, index, currentPath, expanded, onClick } = props;
  let paths = currentPath.split("/")[2];

  return (
    <Link
      to={`${data.userId}`}
      className={`${expanded ? 'justify-start' : 'justify-center'} dashboard-sidebar-middle-menu-closed tooltipp-container`}
      onClick={onClick}
      key={index}
    >
      <div className="tooltippp" dangerouslySetInnerHTML={{ __html: data.userId === paths ? data.svgfill : data.svg }} />
      {!expanded && (
        <div className="tooltipp" style={{ color: data.userId === paths ? "#2576BC" : "#707070" }}>
          {data.name}
        </div>
      )}
      {expanded && (
        <h2
          className="sidebarname font-weight400 font-size-heading"
          style={{
            color: data.userId === paths ? "#2576BC" : "#707070",
            marginLeft: "10px",
            marginTop: "10px"
          }}
        >
          {data.name}
        </h2>
      )}
    </Link>
  );
};

// ------------------------------------------------------------
// DashboardSidebar – main container
// ------------------------------------------------------------
const DashboardSidebar = (props) => {
  const {
    sidebarData,
    isexpand,
    setExpanded,
    mobileMenuOpen,
    closeMobileMenu,
    isMobile,          // new prop
  } = props;

  const [currentPath, setCurrentPath] = useState(window.location.pathname);
  const location = useLocation();
  const [subCompany, setSubCompany] = useState({});

  useEffect(() => {
    setCurrentPath(window.location.pathname);
  }, [location]);

  const handleFormSubmit = (e) => {
    e.preventDefault();
    setExpanded(!isexpand);
  };

  const subCompanyId = sessionStorage.getItem('company_id');

  const getSubCompany = async (subcompanyId) => {
    try {
      const res = await axios.get(`${BASE_URL}/wfm/subcompany-by-id/${subcompanyId}/`);
      setSubCompany(res.data);
    } catch (err) {
      handleErrorToast(err);
    }
  };

  useEffect(() => {
    if (subCompanyId) getSubCompany(subCompanyId);
  }, [subCompanyId]);

  // ── Effective expanded state ──
  // On mobile: when sidebar is open (mobileMenuOpen), force expanded; otherwise respect desktop isexpand.
  const isExpanded = isexpand || (isMobile && mobileMenuOpen);

  return (
    <div className={`
      ${isExpanded ? "dashboard-main-sidebar-section" : "dashboard-main-sidebar-section-closed"}
      ${mobileMenuOpen ? "mobile-open" : ""}
    `}>
      <div className="">
        {/* Logo */}
        <div className="align-center">
          {!isExpanded ? (
            subCompany?.company_logo ? (
              <img className="sidebar-closed-logo-cipl" src={subCompany.company_logo} alt={subCompany.title} />
            ) : (
              <img className="sidebar-closed-logo-cipl" src="/logo.png" alt="logo" />
            )
          ) : (
            <AimantraNameLogo />
          )}
        </div>

        {/* Menu toggle button – hidden on mobile/tablet */}
        {!isMobile && (
          <div className={`font-weight400 font-size-subheading ${isExpanded ? "align-center" : ""}`}>
            <button className="sidebar-title" onClick={handleFormSubmit}>
              Menu
            </button>
          </div>
        )}

        {/* Sidebar items */}
        <div>
          {sidebarData.map((data, index) => {
            return data.subMenu ? (
              <SidebarDropDown
                key={index}
                data={data}
                currentPath={currentPath}
                expanded={isExpanded}           // pass effective expanded
                mobileMenuOpen={mobileMenuOpen}
                onSubItemClick={closeMobileMenu}
              />
            ) : (
              <SidebarLink
                key={index}
                data={data}
                currentPath={currentPath}
                expanded={isExpanded}           // pass effective expanded
                onClick={closeMobileMenu}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default DashboardSidebar;